<template>
    <div class="d-flex justify-content-center">
        <b-img :src="url" class="image-banner" style="max-height: 150px !important;"></b-img>
    </div>
</template>
<script>
export default {
    computed: {
        url() {
            if (!this.currentClient) return ''
            return this.currentClient?.banner_url ?? ''
        },
    },
}
</script>
<style scoped>
.settings {
    height: 120px;
}

.image-banner {
    max-height: 150px;
}

@media screen and (min-width: 640px) {
    .image-banner {
        max-height: 250px !important;
    }
}
</style>
